module.exports = __webpack_public_path__ + "img/gyoza_w_sauce_close-up.1d21557a.jpg";